import { combineReducers } from '@reduxjs/toolkit'
import common, { CommonState } from './commonSlice'
import constants, { ConstantsState } from './constantsSlice'
import tabs, { TabsState } from './tabsSlice'
import tables, { TablesState } from './tablesSlice'

const reducer = combineReducers({
    constants,
    common,
    tabs,
    tables,
})

export type BaseState = {
    common: CommonState
}

export * from './constantsSlice'
export * from './commonSlice'
export * from './tabsSlice'
export * from './tablesSlice'

export default reducer
